import {
  COLORS,
  ATTR,
  DEFAULT_PRODUCT,
  getProduct,
  isProductKey,
} from "../src/shared/config/widget";

export const MIN_HEIGHT = 600;

// Стартовая высота от формы приходит до её полной отрисовки - переспрашивает
const HEIGHT_PING_DELAYS = [0, 300, 800, 1500, 3000];

function requestHeight(
  iframe: HTMLIFrameElement,
  host: string,
  id: string,
): void {
  const origin = new URL(host).origin;
  for (const delay of HEIGHT_PING_DELAYS) {
    window.setTimeout(() => {
      if (!iframe.isConnected) return;
      iframe.contentWindow?.postMessage(
        { event: "request_resize", widgetId: id },
        origin,
      );
    }, delay);
  }
}

export const PREVIEW_ID = "osago-preview";

function buildSrc(host: string, el: HTMLElement, id: string): string {
  const params = new URLSearchParams();
  params.set("utm_source", "iframe");
  params.set("widgetId", id);
  // предпросмотр в конструкторе: сайт не должен подтягивать сюда чужой черновик
  if (id === PREVIEW_ID) params.set("preview", "true");
  params.set("widgetResize", "true");
  params.set("jivochat", "false");
  params.set("header", el.getAttribute(ATTR.showHeader) ?? "false");

  for (const color of COLORS) {
    const raw = el.getAttribute(color.dataAttr);
    if (raw) params.set(color.queryParam, raw.replace(/^#/, ""));
  }

  const rawProduct = el.getAttribute(ATTR.product) ?? "";
  const product = getProduct(isProductKey(rawProduct) ? rawProduct : DEFAULT_PRODUCT);

  if (el.getAttribute(ATTR.hidePromo) === "true") params.set("nopromoimg", "1");
  if (el.getAttribute(ATTR.hideTitle) === "true") params.set("title", "false");

  // Пустой атрибут — расчёт идёт по всем СК, параметр не передаём.
  const companies = el.getAttribute(ATTR.companies) ?? "";
  if (companies) params.set("companies", companies);

  const partner = el.getAttribute(ATTR.partner) ?? "";
  const b = el.getAttribute(ATTR.b) ?? "";
  const chan = el.getAttribute(ATTR.chan) ?? "";

  let hash = "";
  if (partner) {
    hash = `#affid=${partner}`;
    if (b) hash += `&b=${b}`;
    if (chan) hash += `&chan=${encodeURIComponent(chan)}`;
  }

  return `${host}${product.path}?${params.toString()}${hash}`;
}

export function mountWidget(
  host: string,
  el: HTMLElement,
  id: string,
  fullHeight = false,
): void {
  const partner = el.getAttribute(ATTR.partner);
  if (!partner) {
    console.error(
      "[osago-widget] Не задан атрибут data-osago-partner на .osago-widget",
    );
    return;
  }

  const iframe = document.createElement("iframe");
  iframe.src = buildSrc(host, el, id);
  iframe.id = `${id}-frame`;
  iframe.title = "Виджет ОСАГО";
  iframe.setAttribute(
    "sandbox",
    "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads",
  );
  const height = fullHeight ? "100%" : `${MIN_HEIGHT}px`;
  iframe.style.cssText = `width:100%;height:${height};border:0;display:block;`;

  if (!fullHeight) {
    iframe.addEventListener("load", () => requestHeight(iframe, host, id));
  }

  el.replaceChildren(iframe);
}

export function handleWidgetMessage(host: string, event: MessageEvent): void {
  const origin = new URL(host).origin;
  if (event.origin !== origin) return;

  const data = event.data;
  if (!data || typeof data !== "object") return;

  if (data.event === "track" && typeof window._pEvent === "function") {
    window._pEvent(data.type);
    return;
  }

  if (!data.widgetId) return;
  const iframe = document.getElementById(
    `${data.widgetId}-frame`,
  ) as HTMLIFrameElement | null;
  if (!iframe) return;

  if (data.event === "resize" && data.height) {
    iframe.style.height = `${Math.max(Number(data.height), MIN_HEIGHT)}px`;
  } else if (data.event === "scroll_to_top") {
    iframe.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
